export default __webpack_public_path__ + "static/src/assets/images/icons/light/trade_icon_cancel_normal.png";